import SelectCurrenciesSingle from './select-currencies-single';
export default SelectCurrenciesSingle;
